module.exports = __webpack_public_path__ + "static/zoe-web-arm@3x-c3e78d594eaad611d16b4f01569315c7.jpg";